import { render, staticRenderFns } from "./TravelServiceView.vue?vue&type=template&id=64b6342d&scoped=true&"
import script from "./TravelServiceView.vue?vue&type=script&lang=js&"
export * from "./TravelServiceView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b6342d",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VCol,VCombobox,VRow,VSpacer,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64b6342d')) {
      api.createRecord('64b6342d', component.options)
    } else {
      api.reload('64b6342d', component.options)
    }
    module.hot.accept("./TravelServiceView.vue?vue&type=template&id=64b6342d&scoped=true&", function () {
      api.rerender('64b6342d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/travel-service/TravelServiceView.vue"
export default component.exports